import { Link } from "react-router-dom";
import NewsletterForm from "./NewsletterForm";

const linkGroups = [
  {
    title: "Shop",
    links: [
      { label: "New Arrivals", to: "/shop" },
      { label: "Outerwear", to: "/shop" },
      { label: "Knitwear", to: "/shop" },
      { label: "Accessories", to: "/shop" },
    ],
  },
  {
    title: "About",
    links: [
      { label: "Our Story", to: "/story" },
      { label: "Sustainability", to: "/sustainability" },
      { label: "Materials", to: "/sustainability" },
      { label: "Journal", to: "/story" },
    ],
  },
  {
    title: "Support",
    links: [
      { label: "Contact", to: "/" },
      { label: "Shipping", to: "/" },
      { label: "Returns", to: "/" },
      { label: "Care Guide", to: "/" },
    ],
  },
  {
    title: "Connect",
    links: [
      { label: "Instagram", to: "/" },
      { label: "Pinterest", to: "/" },
      { label: "TikTok", to: "/" },
      { label: "LinkedIn", to: "/" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="relative bg-forest text-bone overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, rgba(245,241,234,0.6) 1px, transparent 0)",
          backgroundSize: "24px 24px",
        }}
      />

      <div className="relative px-6 md:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Left brand + newsletter */}
          <div className="lg:col-span-5">
            <div className="font-display text-3xl md:text-4xl tracking-tightest text-bone flex items-center gap-2">
              Verdant<span className="w-2 h-2 rounded-full bg-rust inline-block"></span>
            </div>

            <h4 className="mt-10 font-display text-3xl md:text-[42px] leading-[1.05] tracking-tightest max-w-md">
              Slow letters from the studio, four times a year.
            </h4>

            <div className="mt-8 max-w-md">
              <NewsletterForm />
            </div>

            <p className="mt-6 text-xs text-bone/60 max-w-md leading-relaxed">
              No noise. Only first looks at collections, mill visits, and field notes from our regenerative partners.
            </p>
          </div>

          {/* Right link groups */}
          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-4 gap-10">
            {linkGroups.map((group) => (
              <div key={group.title}>
                <h4 className="text-[11px] font-mono uppercase tracking-[0.18em] text-bone/50">
                  {group.title}
                </h4>
                <ul className="mt-5 space-y-3">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.to}
                        className="text-sm text-bone/90 hover:text-bone transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-bone/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <p className="text-xs text-bone/60">© 2026 Verdant Atelier. Made with intention in Porto, Portugal.</p>
          <div className="flex items-center gap-3">
            {["instagram-line", "pinterest-line", "tiktok-line", "linkedin-line"].map((icon) => (
              <a
                key={icon}
                href="#"
                aria-label={icon}
                className="w-9 h-9 flex items-center justify-center rounded-full border border-bone/30 hover:border-bone hover:bg-bone hover:text-forest transition-all cursor-pointer"
              >
                <i className={`ri-${icon} text-sm`}></i>
              </a>
            ))}
          </div>
          <div className="flex items-center gap-6 text-xs text-bone/60">
            <a href="#" className="hover:text-bone cursor-pointer">Privacy</a>
            <a href="#" className="hover:text-bone cursor-pointer">Terms</a>
            <a href="#" className="hover:text-bone cursor-pointer">Cookies</a>
          </div>
        </div>
      </div>

      <div className="relative overflow-hidden border-t border-bone/10">
        <div className="flex whitespace-nowrap animate-marquee py-6">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="flex items-center shrink-0">
              {["Regenerative cotton", "GOTS certified", "Carbon negative", "Zero waste pattern", "Slow fashion", "Made to last", "Repair, rewear, rewild"].map((t, j) => (
                <span key={`${i}-${j}`} className="flex items-center shrink-0">
                  <span className="font-display text-5xl md:text-7xl tracking-tightest text-bone/15 px-6">{t}</span>
                  <span className="w-2 h-2 rounded-full bg-rust/60 inline-block"></span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </footer>
  );
}